/** Country codes with a matching asset under `/public/flags/{code}.svg`.
 *  SVG (not emoji): Windows has no flag glyphs, so Edge/Chrome there render
 *  regional-indicator pairs as plain letters.
 *
 *  Assets are 4×3 SVGs from lipis/flag-icons (MIT), except `es` which uses the
 *  civil stripes only — the full arms coat is unreadable at 18–26px and bloated
 *  the header.
 *
 *  The set was six codes (the languages the site speaks) until the phone country
 *  picker needed every country a patient might call from. It is now the full
 *  libphonenumber country list, so the type can no longer be a hand-written union:
 *  a lowercase ISO 3166-1 alpha-2 string IS the contract, and
 *  {@link hasFlagAsset} is how a caller checks before rendering. */
export type FlagCode = string;

/** The two selectable countries with no asset in flag-icons: Ascension Island and
 *  Tristan da Cunha. Both are +247/+290 dependencies of Saint Helena with a
 *  population in the hundreds — they stay selectable (the dial code is what
 *  matters), they just render the neutral placeholder. */
const MISSING_FLAG_ASSETS = new Set(['ac', 'ta']);

/** Whether `/public/flags/{code}.svg` exists, so a caller can fall back instead of
 *  rendering a broken image. */
export function hasFlagAsset(code: string): boolean {
  const c = code.trim().toLowerCase();
  return /^[a-z]{2}$/.test(c) && !MISSING_FLAG_ASSETS.has(c);
}
